// extracted by mini-css-extract-plugin
export var deepDiveStyles = "deep-dive-module--deepDiveStyles--vc+ss";
export var globeStyles = "deep-dive-module--globeStyles--QHl39";
export var handStyles = "deep-dive-module--handStyles--LtdAt";